export const ONE_DAY_IN_SECONDS = 24 * 60 * 60;
